import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import LifeMartFunnel from "@/pages/LifeMartFunnel";

// Kept live as of 2026-08-06 (real recent activity observed) -- see
// src/config/featureFlags.ts LIFEMART_PUBLIC_PAGES_ENABLED doc comment.
export const Route = createFileRoute("/lifemart/survey")({
  head: () => seoHead("/lifemart/survey"),
  component: LifeMartFunnel,
});
